import { queryClient } from "@/client";
import { useMutation } from "@tanstack/react-query";

import { getAllProductsKey } from "@/hooks/api/predictive/product/useGetAllProducts";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const useUpdateCampaignToActive = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (campaignId: string) =>
      apiClient.predictiveCampaigns.activate({
        id: campaignId,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: getAllProductsKey }),
  });

  return {
    ...mutation,
    setCampaignToActive: mutation.mutate,
    setCampaignToActiveAsync: mutation.mutateAsync,
  };
};
